import Menu from '@/global/components/MenuV2'
import { Box, Divider, Grid, Typography } from '@mui/material'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import { LockIcon } from 'lucide-react'
import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

export const PontoWeb: React.FC = () => {
    const { watch, setValue } = useFormContext()
    const [registroApp, reconhecimentoFacial, dtRescisao] = watch([
        'registroApp',
        'reconhecimentoFacial',
        'dtRescisao',
    ])

    useEffect(() => {
        if (!registroApp) setValue('reconhecimentoFacial', 0)
        else if (registroApp && reconhecimentoFacial === 0)
            setValue('reconhecimentoFacial', 1)
    }, [registroApp])

    return (
        <Box component="section" id="ponto-web">
            <Divider sx={{ marginBottom: 2, marginTop: 1 }} textAlign="center">
                Registro de ponto
            </Divider>
            <Overlay>
                <Grid container columns={24} spacing={1} columnSpacing={2}>
                    <Grid item xs={12}>
                        <FormFieldCheckbox
                            name="verSaldoHoras"
                            label="Permite ver o saldo de horas"
                            disabled={!!dtRescisao}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormFieldCheckbox
                            name="registroWeb"
                            label="Permite registro pela web"
                            disabled={!!dtRescisao}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormFieldCheckbox
                            name="registroApp"
                            label="Permite registro pelo app"
                            disabled={!!dtRescisao}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormFieldCheckbox
                            name="ajustesPonto"
                            label="Permite solicitar ajustes de registros"
                            disabled={!!dtRescisao}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            select
                            label="Método de registro"
                            name="reconhecimentoFacial"
                            disabled={!registroApp || !!dtRescisao}
                            defaultValue={0}
                        >
                            <Menu.Item value={0} disabled>
                                Não permitido
                            </Menu.Item>
                            <Menu.Item value={1}>Por clique</Menu.Item>
                            <Menu.Item value={2}>Selfie</Menu.Item>
                            <Menu.Item value={3}>
                                Reconhecimento facial
                            </Menu.Item>
                        </FormField>
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            name="pontoDiferenciado"
                            label="Ponto diferenciado"
                            select
                            disabled={!!dtRescisao}
                        >
                            <Menu.Item value="NORMAL">Normal</Menu.Item>
                            <Menu.Item value="EXCECAO">Exceção</Menu.Item>
                            <Menu.Item value="PRE_ASSINALADO">
                                Pré-assinalado
                            </Menu.Item>
                            <Menu.Item value="SEM_INTERVALO">
                                Sem intervalo
                            </Menu.Item>
                        </FormField>
                    </Grid>
                </Grid>
            </Overlay>
        </Box>
    )
}

function Overlay({ children }: { children: React.ReactNode }) {
    const { watch } = useFormContext()
    const bloqueado = watch('dtRescisao')

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%',
            }}
        >
            {!!bloqueado && (
                <Box
                    sx={{
                        position: 'absolute',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(5px)',
                        pointerEvents: 'none',
                        zIndex: 10,
                        cursor: 'not-allowed',
                    }}
                >
                    <LockIcon className="text-primary size-20" />
                    <Typography
                        variant="h5"
                        sx={{
                            color: 'white',
                            marginLeft: 2,
                            textTransform: 'uppercase',
                        }}
                    >
                        Funcionário rescindido
                    </Typography>
                </Box>
            )}
            {children}
        </Box>
    )
}
